import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useAppDispatch } from 'core/store/hooks';
import AuthService from 'core/auth/auth.service';
import { authStopImpersonation } from 'pages/auth/_redux/actions';
import './style.scss';

const AppImpersonationBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isStopping, setIsStopping] = useState(false);

  if (!AuthService.isImpersonating()) return null;

  const user = AuthService.getUser();
  const targetName = user ? user.name : '-';
  const impersonatorUsername = AuthService.getImpersonationInfo()?.impersonatorUsername ?? '-';

  const handleStopImpersonation = () => {
    setIsStopping(true);
    dispatch(authStopImpersonation()).finally(() => {
      setIsStopping(false);
    });
  };

  return (
    <div className="alert alert-warning app-impersonation-banner d-flex justify-content-between align-items-center mb-0" role="alert">
      <span>
        {t('Stai impersonando')} <strong>{targetName || '-'}</strong> ({t('avviata da')} {impersonatorUsername})
      </span>
      <Button variant="dark" size="sm" disabled={isStopping} onClick={handleStopImpersonation}>
        {isStopping ? t('Interruzione in corso...') : t('Interrompi impersonazione')}
      </Button>
    </div>
  );
};
export default AppImpersonationBanner;
